import { render, staticRenderFns } from "./ques9_1.vue?vue&type=template&id=154c8fb3"
import script from "./ques9_1.vue?vue&type=script&lang=js"
export * from "./ques9_1.vue?vue&type=script&lang=js"
import style0 from "./ques9_1.vue?vue&type=style&index=0&id=154c8fb3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports